(function () {
  'use strict';

  function addToQuoteCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to quote cart failed');
      return res.json();
    });
  }

  function updateCartCountBadges() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-quote-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function importSharedPreventivo() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('preventivo');
    if (!raw) return;

    var items = raw.split(',').map(function (pair) {
      var parts = pair.split(':');
      return { id: parseInt(parts[0], 10), quantity: parseInt(parts[1], 10) || 1 };
    }).filter(function (i) { return i.id; });

    if (!items.length) return;

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function () {
        window.location.replace('/cart');
      })
      .catch(function () {
        window.location.replace('/cart');
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateCartCountBadges();
    importSharedPreventivo();

    document.body.addEventListener('click', function (evt) {
      var btn = evt.target.closest('.js-add-to-quote');
      if (!btn) return;
      evt.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Aggiunta in corso...';

      addToQuoteCart(variantId, 1)
        .then(function () {
          btn.textContent = 'Aggiunto ✓';
          updateCartCountBadges();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = 'Errore, riprova';
          btn.disabled = false;
        });
    });
  });
})();
